/**
 * 
 * @param {Date} date 
 * @returns
 */
export const getDateString = (date) => {
  return date.toLocaleDateString('ru-RU').split('.').reverse().join('-');
}



// WEBPACK FOOTER //
// ./src/templates/pages/events/helpers.js